/* global URL, fetch */
import fetchIntercept from 'fetch-intercept';
import {Oauth, OauthError} from './oauth';

export function interceptFactory(myConfig) {
  if(!Array.isArray(myConfig.urlPatterns)) {
    myConfig.urlPatterns = [myConfig.urlPatterns];
  }
  const myOauth = new Oauth(myConfig);

  const addBearerToken = async function(requestConfig, url) {
    const newConfig = Object.assign({}, requestConfig, {headers: Object.assign({}, requestConfig.headers)});
    // const newConfig = {...requestConfig, ...{ headers: {...requestConfig.headers} }};
    if(requestConfig && requestConfig.headers && requestConfig.headers.Authorization) {
      console.log('[oauth interceptor ' + url + '] There already is an Authorization header on the request: ', requestConfig.headers.Authorization);
    }

    try {
      const bearerToken = await myOauth.getBearerToken();
      /*if instanceof Headers -> headers.append(...) = new Headers({
        'AUTHORIZATION': `Bearer ${bearerToken.value}`
      });*/
      newConfig.headers.Authorization = 'Bearer ' + bearerToken.value;
    } catch(error) {
      if(error instanceof OauthError) {
        if(error.code === 'redirected.to.login.page') {
          console.warn('[oauth interceptor ' + url + '] /authenticate responded with the login page. We will redirect to the login page.');
          if(myConfig.onLoggedOut) {
            myConfig.onLoggedOut();
          } else {
            myOauth.redirectToLogin();
          }
        }
      } else {
        console.error('[oauth interceptor ' + url + '] unexpected error occured when fetching the Bearer token. It is not added to the request', error);
      }
    }
    return newConfig;
  };

  const handle401 = async function(response) {
    try {
      myOauth.invalidateBearerToken();
      const contentType = response.headers.get('content-type');
      if(!contentType.match(/application\/json/g)) {
        console.log('[oauth interceptor ' + response.url + '] The content type of the response for status 401 is no JSON. We can not do anything with this', contentType);
        return response;
      }
      let resp = {};
      try {
        resp = await response.json();
      } catch(err) {
        try {
          console.error('[oauth interceptor ' + response.url + '] Parsing the json failed, we will try make text of it');
          resp = await resp.text();
          console.log('[oauth interceptor ' + response.url + '] the text: ', resp);
        } catch (err) {
          console.log('[oauth interceptor ' + response.url + '] also making text of it failed!', response);
        }
      }
      if (Array.isArray(resp)) {
        resp = resp.find(obj => obj.status === 401).body;
        if (resp.errors) {
          resp = resp.errors.find(err => err.code.match(/^oauth.*$/)) || resp.errors[0];
        }
      }
      if(resp.code === 'oauth.bearerAuthTokenInvalid' || resp.code === 'oauth.bearerAuthUserLoggedOut') {
        console.log('[oauth interceptor ' + response.url + '] got 401 with code '+resp.code+', we will redirect to the login page...');
        myOauth.redirectToLogin();
      } else if(resp.code === 'oauth.bearerAuthTokenExpired') {
        console.log('[oauth interceptor ' + response.url + '] got 401 with code '+resp.code+', we will refresh the token...');
        myOauth.invalidateBearerToken();
        const originalRequest = pendingRequests[response.url];
        if(!originalRequest) {
          console.warn('[oauth interceptor ' + response.url + '] Why is there no original request????');
        }
        return await fetch(response.url, originalRequest);
      } else {
        console.warn('[oauth interceptor ' + response.url + '] got 401 with code '+resp.code+', we dont know what to do!');
      }
      return response;
    } catch(error) {
      console.log('[oauth interceptor ' + response.url + '] an error occured trying to intercept 401', error);
    }
  };

  const interceptMe = async (originalResponse) => {
    if(myOauth.user) {
      return;
    }
    console.log('[oauth interceptor] intercept /me');
    myOauth.meCheckIsDone();
    try {
      const response = originalResponse.clone();
      if(response.ok) {
        const me = await response.json();
        if(myOauth.user && me.uuid !== myOauth.user) {
          console.warn('[oauth interceptor /me] The loged in user is not the same user anymore. We will invalidate the bearer token! The old user was ' + myOauth.user);
          myOauth.invalidateBearerToken();
        }
        myOauth.setUser(me.uuid);
      } else if(response.status === 403) {
        console.warn('[oauth interceptor /me] Got 403 when trying to fetch /me, we will redirect to the login page.');
        myOauth.invalidateBearerToken();
        if(myConfig.onLoggedOut) {
          myConfig.onLoggedOut();
        } else {
          myOauth.redirectToLogin();
        }
      }
    } catch(error) {
      console.log('[oauth interceptor /me] An error occured when trying to intercept /me', error);
    }
  };

  const interceptLogIn = async (originalResponse) => {
    try {
      const response = originalResponse.clone();
      if(response.ok) {
        const contentType = response.headers.get('content-type');
        if(contentType.match(/application\/json/)) {
          const loginResp = await response.json();
          console.log('[oauth interceptor] intercepting /login to set access token', loginResp);
          myOauth.setBearerToken(loginResp.access_token, loginResp.access_token_expires_in ? loginResp.access_token_expires_in : 90);
        }
      }
    } catch(error) {
      console.log('[oauth interceptor /login] An error occured when trying to intercept /login', error);
    }
  };

  const logOutExp = new RegExp(myConfig.oauth.oauthURL + '/logout', 'g');
  const logInExp = new RegExp(myConfig.oauth.oauthURL + '/login', 'g');
  const meExp = new RegExp(myConfig.oauth.oauthURL +'/me', 'g');

  const needsKathOndVlaAuthentication = (url, method) => {
    const matchOneOfUrls = myConfig.urlPatterns.reduce((isMatch, urlPattern) => {
      return isMatch ? true : !!url.match(urlPattern);
    }, false);
    if(!matchOneOfUrls) {
      return false;
    }

    if(method === 'GET' && myConfig.ignore && myConfig.ignore.get) {
      for(let path of myConfig.ignore.get) {
        if(url.match(path)) {
          return false;
        }
      }
    }
    if(method === 'POST' && myConfig.ignore && myConfig.ignore.post) {
      for(let path of myConfig.ignore.post) {
        if(url.match(path)) {
          return false;
        }
      }
    }
    if(method === 'PUT' && myConfig.ignore && myConfig.ignore.put) {
      for(let path of myConfig.ignore.put) {
        if(url.match(path)) {
          return false;
        }
      }
    }

    return true;
  };

  const pendingRequests = {};
  fetchIntercept.register({
    request: async function (url, requestConfig = {}) {
      const urlString = url instanceof URL ? url.href : url;
      if(urlString && needsKathOndVlaAuthentication(urlString, requestConfig.method)) {
        pendingRequests[urlString] = requestConfig;
        const newConfig = await addBearerToken(requestConfig, urlString);
        return [url, newConfig];
      } else if(urlString && urlString.match(logOutExp)) {
        console.log('[oauth interceptor] user loged out we will invalidate bearer token.');
        myOauth.invalidateBearerToken();
      }
      return [url, requestConfig];
    },

    requestError: function (error) {
      console.log('[oauth-interceptor] fetch intercept request! do we get here?', error);
      return Promise.reject(error);
    },

    response: async function (response) {
      if(needsKathOndVlaAuthentication(response.url)) {
        if(response.status === 401) {
          const newResponse = await handle401(response);
          return newResponse;
        }
        delete response.url;
      } else if(response.url.match(meExp)) {
        await interceptMe(response);
      } else if(response.url.match(logInExp)) {
        await interceptLogIn(response);
      }
      return response;
    },

    responseError: function (error) {
      console.log('[oauth-interceptor] fetch intercept error', error);
      return Promise.reject(error);
    }
  });
}
